import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Destinations from '../speed-dial/Destinations';

type FacilitySpeedDialTabProps = {
  facility: Facility;
};

const FacilitySpeedDialTab: React.FC<FacilitySpeedDialTabProps> = ({ facility }) => {
  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="content">
        <Destinations facility={facility} />
      </div>
    </div>
  );
};

export default FacilitySpeedDialTab;
